import React from 'react';
import { CountDownText, HeaderText, StyledDivider, StyledHeader, HeaderContainer } from '../../RegistryGiftAdvisor.styles';
import { Tooltip } from '../Tooltip';
import { Flex, IconButton } from '@withjoy/joykit';
import { CustomCard as EditIcon } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';

interface AdvisorHeaderProps {
  isEditing: boolean;
  countDownValue: string;
  guestCount?: number;
  initialGuestCount: number;
  handleOnEditClick: () => void;
  isMobile?: boolean;
}

const AdvisorHeader: React.FC<AdvisorHeaderProps> = ({ isEditing, countDownValue, guestCount, initialGuestCount, handleOnEditClick, isMobile = false }) => {
  const { t } = useTranslation('sharedComponents');
  const registryTexts = t('registryGiftCounts');
  const { registryAdvisor, guestSummary } = t('registryGiftAdvisorV2');
  const Container = isMobile ? HeaderContainer : StyledHeader;

  return (
    <>
      <Container
        padding={5}
        paddingX={!isMobile ? 6 : undefined}
      >
        <Flex alignItems="center">
          <HeaderText
            typographyVariant="hed3"
            marginRight={2}
          >
            {registryAdvisor()}
          </HeaderText>
          <Tooltip />
        </Flex>
        {!isEditing && (
          <Flex marginTop={isMobile ? 2 : 0}>
            <CountDownText marginRight={5}>{countDownValue}</CountDownText>
            <CountDownText marginRight={1}>{guestSummary({ count: guestCount ?? initialGuestCount })}</CountDownText>
            <IconButton
              minWidth={pxToRem(22)}
              height={pxToRem(22)}
              color="mono10"
              variant="ghost"
              aria-label={registryTexts.ariaEditLabel()}
              onClick={handleOnEditClick}
            >
              <EditIcon />
            </IconButton>
          </Flex>
        )}
      </Container>
      <StyledDivider />
    </>
  );
};

export default AdvisorHeader;
